module.exports = __webpack_public_path__ + "img/s2P26.fd6a8eb6.png";